import SignalRService from './SignalRService';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { acdEvent, pausesList, setFunctions, setPhoneStatus } from '../redux/agentSlice';
import { setJanusParameters, setJanusAgent, setSearchForm } from '../redux/parametersSlice';
import ToastrCustom from '../components/utils/toastrcustom';
import { useNavigate } from "react-router-dom";

//* This dispacher is used to update react redux slices without any view being redered
class EventDispacherService extends Component {


    constructor(props) {

        super(props)
        this.toastrRef = React.createRef();

    }

    async componentDidMount(nextProps, nextState) {

        if (!("Notification" in window)) {
            console.log("Browser does not support desktop notification");
        } else {
            Notification.requestPermission();
        }

        SignalRService.registerACDEvent( this.props.acdEvent);
        SignalRService.registerCTIEvent(this.props.setPhoneStatus);
        SignalRService.registerFunctionsEvent(this.props.setFunctions);
        SignalRService.registerFunctionsEvent(this.props.setJanusAgent);

        SignalRService.registerURLEvent(message => {
            this.props.setSearchForm(message.search);
        });


    }

    render() {
        return (
            <>
                <ToastrCustom ref={this.toastrRef} select={this.select} />
            </>)
    };
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <EventDispacherService {...props} navigate={navigate} />
}

export default connect(null, { acdEvent, pausesList, setFunctions, setJanusParameters, setJanusAgent, setPhoneStatus, setSearchForm })(WithNavigate);